import React from 'react'
import PropTypes from 'prop-types'
import { majorScale, minorScale, Avatar, Icon, Pane } from 'evergreen-ui'

export default class AvatarDropdown extends React.PureComponent {
  static propTypes = {
    /**
     * Composes the Pane spec from Evergreen.
     */
    ...Pane.propTypes,

    /**
     * Props forwarded to the avatar
     */
    avatarProps: PropTypes.object
  }

  render() {
    const { avatarProps, ...props } = this.props
    return (
      <Pane
        tabIndex={0}
        role="button"
        display="flex"
        cursor="pointer"
        alignItems="center"
        {...props}
      >
        <Avatar size={majorScale(4)} color="green" isSolid {...avatarProps} />
        <Icon
          icon="caret-down"
          marginLeft={minorScale(1)}
          size={minorScale(4)}
          color="inherit"
        />
      </Pane>
    )
  }
}
